import React from "react";
import styled from "styled-components";
import { prop } from "styled-tools";

import ebook from "assets/images/ebook.png";
import ligonier from "assets/images/ligonier-logo.svg";

/*
 * Styles
 */

const Container = styled.div`
  margin-top: 4rem;
  padding: 4rem 0;
  position: relative;
  &::before {
    background-color: ${prop("theme.colors.grayT")};
    height: 1px;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  @media (min-width: 66em) {
    &::before {
      margin-left: -4rem;
      margin-right: -4rem;
    }
  }
  @media (min-width: 76em) {
    &::before {
      margin-left: -8rem;
      margin-right: -8rem;
    }
  }
  @media (min-width: 86em) {
    &::before {
      margin-left: -12rem;
      margin-right: -12rem;
    }
  }
`;

const Card = styled.a`
  align-items: center;
  background-color: ${prop("theme.colors.grayTTT")};
  cursor: pointer;
  display: flex;
  gap: 0.4rem;
  justify-content: center;
  margin-bottom: 4rem;
  padding: 1.6rem 0;
  text-decoration: none;
  &:hover,
  &:focus {
    background-color: ${prop("theme.colors.blueTTT")};
  }
  img {
    width: 6rem;
  }
  em {
    display: block;
  }
  p {
    margin: 0 0 1.2rem;
  }
  @media (min-width: 30em) {
    gap: 0.8rem;
    img {
      width: 8rem;
    }
  }
  @media (min-width: 40em) {
    gap: 1.6rem;
  }
`;

const CardLink = styled.span`
  background: ${prop("theme.colors.blue")};
  color: white;
  border-radius: 0.2rem;
  color: white;
  display: inline-block;
  font-size: ${prop("theme.scale.down1")};
  letter-spacing: 0.125em;
  line-height: 1.2rem;
  padding: 0.4rem 1.2rem;
  text-transform: uppercase;
  transition: all 200ms ease;
  &:hover,
  &:focus {
    background: ${prop("theme.colors.blueS")};
    color: white;
  }
`;

const Copyright = styled.div`
  font-size: ${prop("theme.scale.down1")};
  text-align: center;
  img {
    opacity: 0.5;
  }
`;

/*
 * Component
 */

const Footer = () => (
  <Container>
    <Card href="https://gift.ligonier.org/751/everyones-theologian">
      <img src={ebook} alt="Everyone’s a Theologian by R.C. Sproul" />
      <div>
        <p>
          Download
          <em>Everyone’s a Theologian</em>
          by R.C. Sproul for free.
        </p>
        <CardLink>Claim your eBook</CardLink>
      </div>
    </Card>

    <Copyright>
      <img src={ligonier} alt="Ligonier Ministries" />
      <br />
      An Outreach of <a href="http://www.ligonier.org/">Ligonier</a> © 2022 |{" "}
      <a href="https://www.ligonier.org/privacy-policy/">Privacy Policy</a>
    </Copyright>
  </Container>
);

export default Footer;
